<template>
	<div
		:class="[
			'c-reading-item',
			{ active: active === true },
			{ expand: expand === true },
			{ focus: focus === true },
		]"
		tabindex="0"
		v-if="visible"
		:data-id="note.id"
		draggable="true"
		@focus="onFocus"
		@blur="onBlur"
		@dragstart="onDragstart"
		@dragend="onDragend"
		@dragover="onDragover"
	>
		<div
			:class="['c-reading-item__sidebar', 'c' + bucket.color]"
			:title="bucket.title"
		>
			<avatar
				size="lg"
				:text="note.domain"
				:domain="note.domain"
				v-if="showAvatar"
			></avatar>
			<div
				:class="['checkbox-control icon', { selected: isSelected }]"
				@click="onSelect($event)"
			>
				<span>
					<check-icon size="1x"></check-icon>
				</span>
			</div>
		</div>
		<div class="c-reading-item__main">
			<div>
				<span class="divider" v-if="showBucket && bucket">·</span>
				<span
					v-if="showBucket && bucket"
					:title="bucket.title"
					:class="['badge', 'c' + bucket.color]"
					v-html="getTitle(bucket.title)"
				></span>
			</div>
			<!-- <a
				v-if="isYoutubeVideo"
				class="video"
				:href="`https://youtu.be/${note.meta.resource.id}?t=292`"
				target="_blank"
			>
				<img
					:src="`https://img.youtube.com/vi/${note.meta.resource.id}/sddefault.jpg`"
					class="img-fluid"
				/>
				<scrubber
					:currentTime="note.meta.video.timestamp.time"
					:totalTime="note.meta.video.timestamp.totalTime"
				></scrubber>
			</a> -->
			<TextRenderer
				v-if="note.type !== 'text' || note.type !== 'code'"
				:note="note"
			></TextRenderer>
			<BookmarkRenderer
				v-if="note.type === 'bookmark'"
				:note="note"
			></BookmarkRenderer>
			<!-- <ImageRenderer :note="note"></ImageRenderer> -->
			<!-- <pre v-if="isYoutubeVideo">
				{{ note }}
			</pre
			> -->
			<VideoRenderer v-if="note.type === 'video'" :note="note"></VideoRenderer>
			<CommentRenderer :note="note" />
			<!-- <ReadingItemDetail v-if="active" :note="note"></ReadingItemDetail> -->
		</div>
		<ListControls
			:id="note.id"
			:disableCopy="note.type === 'bookmark'"
			@clickHandler="onClick"
		></ListControls>
	</div>
</template>

<script>
import tt from '@/lib/trim-text.js';
import youtubeHelper from '@/lib/youtube-helper.js';
import avatar from '@/components/ui/avatar.vue';
import scrubber from '@/components/ui/scrubber.vue';
import TextRenderer from '@/components/dashboard/text-renderer';
import BookmarkRenderer from '@/components/dashboard/bookmark-renderer';
import VideoRenderer from '@/components/dashboard/video-renderer';
import CommentRenderer from '@/components/dashboard/comment-renderer';
import ListControls from '@/components/dashboard/list-controls';
import ImageRenderer from '@/components/dashboard/image-renderer';
import ReadingItemDetail from '@/components/dashboard/reading-item-detail';

import moment from 'moment';
import {
	CheckIcon,
	MessageCircleIcon,
	FileTextIcon,
	BookmarkIcon,
	CodeIcon,
	Edit2Icon,
} from 'vue-feather-icons';

export default {
	components: {
		CheckIcon,
		MessageCircleIcon,
		FileTextIcon,
		BookmarkIcon,
		CodeIcon,
		avatar,
		Edit2Icon,
		scrubber,
		TextRenderer,
		BookmarkRenderer,
		VideoRenderer,
		ImageRenderer,
		CommentRenderer,
		ListControls,
		ReadingItemDetail,
	},
	data: function () {
		var obj = {
			focus: false,
			dragover: false,
			expand: false,
			wordCount: 72,
			commentCount: 140,
			active: false,
		};
		return obj;
	},
	props: ['note', 'showBucket', 'headerKey', 'showAvatar', 'forceOpen'],
	computed: {
		visible: function () {
			if (this.forceOpen) {
				return true;
			}
			if (this.$store.getters['ui/isHeaderKeyHidden'](this.headerKey)) {
				return true;
			} else {
				return false;
			}
		},
		buckets: function () {
			return this.$store.getters['bucket/buckets'];
		},
		bucket: function () {
			if (this.note.bucket) {
				return this.$store.getters['bucket/bucket'](this.note.bucket);
			} else {
				return false;
			}
		},
		selectedNotes: function () {
			return this.$store.getters['note/selectedNotes'];
		},
		isSelected: function () {
			if (this.selectedNotes.length < 1) {
				return false;
			}
			if (this.selectedNotes.includes(this.note.id)) {
				return true;
			} else {
				return false;
			}
		},
		isVideo: function () {
			if (this.note.meta && this.note.meta.video && this.note.meta.resource) {
				return true;
			} else {
				return false;
			}
		},
		isYoutubeVideo: function () {
			if (
				this.isVideo &&
				this.note.meta.resource &&
				this.note.meta.resource.service === 'youtube'
			) {
				return true;
			} else {
				return false;
			}
		},
		videoThumbnail: function () {
			return `http://img.youtube.com/vi/${this.note.meta.resource.id}/mqdefault.jpg`;
		},
		scrubberStyle: function () {
			let style = {};
			if (this.isVideo) {
				let currentSeconds = youtubeHelper.timeToSeconds(
					this.note.meta.video.timestamp.time
				);
				let totalSeconds = youtubeHelper.timeToSeconds(
					this.note.meta.video.timestamp.totalTime
				);
				let pos = youtubeHelper.scaleValue(
					currentSeconds,
					[0, totalSeconds],
					[0, 100]
				);
				style.left = pos + '%';
			}
			return style;
		},
		date: function () {
			var m = moment(this.note.createdAt).fromNow();
			return m;
		},
		bookmark: function () {
			if (this.note.meta && this.note.meta.bookmark) {
				return true;
			} else {
				return false;
			}
		},
		file: function () {
			if (this.note.meta && this.note.meta.file) {
				return true;
			} else {
				return false;
			}
		},
		code: function () {
			if (this.note.type === 'code') {
				return true;
			} else {
				return false;
			}
		},
		comment: function () {
			if (this.note.comment && this.note.comment.raw) {
				return this.note.comment.html;
			} else {
				return false;
			}
		},
		beautifyLink: function () {
			var href = this.note.href;
			if (!href) {
				return '';
			}
			href = href.replace('https://', '');
			href = href.replace('http://', '');
			href = href.split('?');
			href = href[0];
			href = tt(href, 32, 'char');
			return href;
		},
	},
	methods: {
		onFocus: function () {
			this.focus = true;
		},
		onBlur: function () {
			this.focus = false;
		},
		onDragover: function () {
			this.dragover = true;
		},
		onDragend: function (e) {
			this.$store.dispatch('dashboard/dragStopped');
			const data = {
				mouse: {
					x: event.pageX,
					y: event.pageY,
				},
				notes: [this.note.id],
			};
			// this.$store.dispatch('user/onDragend', data).then((res) => {
			// 	console.log(res);
			// });
			window.parent.postMessage(JSON.stringify(data));
		},
		onDragstart: function (e) {
			this.$store.dispatch('dashboard/dragStarted');
			e.dataTransfer.setData('text', JSON.stringify([this.note.id]));
			window.parent.postMessage('dragstarted');
		},
		// onBlur: function () {
		// 	this.expand = false;
		// },
		// onFocus: function () {
		// 	this.expand = true;
		// 	this.$emit('onPreview');
		// },
		getTitle: function (str) {
			str = str.split('|');
			if (str[1]) {
				let temp2 = str[0];
				let temp = [str.shift(), str.join('|')];
				return `${temp2}<br /> <span class="muted">${str}</span>`;
			} else {
				return str[0];
			}
		},
		onSelect: function (e) {
			let shiftSelect = false;
			if (e.shiftKey) {
				this.$emit('shiftSelect', this.note);
			} else if (e.ctrlKey) {
				this.$emit('ctrlSelect', this.note);
			} else {
				this.$store.commit('note/TOGGLE_SELECTION', this.note);
			}
		},
		onClick: function (action, el) {
			if (action === 'external-link') {
				this.onExternalLink(this.note.href);
			}
			if (action === 'open') {
				this.$store.dispatch('dashboard/setSelectedNote', this.note.id);
			}
			if (action === 'comment') {
				this.$emit('comment', this.note);
			}
			if (action === 'copy') {
				this.$copyText(this.note.text);
			}
			if (action === 'smartcopy') {
				this.$store.dispatch('smartCopy/getCopy', this.note).then((str) => {
					this.$copyText(str);
				});
			}
		},
		onExternalLink: function (url) {
			window.open(url, '_blank');
		},
	},
};
</script>

<style lang="scss">
.c-reading-item {
	display: flex;
	position: relative;
	width: calc(100% - 10px);
	margin-top: 0;
	margin-bottom: var(--spacer-sm);
	min-height: 31px;
	transition: background-color 100ms linear;
	border-radius: var(--border-radius);

	&:focus {
		outline: none;
	}

	&.focus {
		@include focus();
		// padding: var(--margin-lg) 0;
		// background-color: var(--g2);
		// border-radius: var(--border-radius);
	}

	.badge {
		.muted {
			display: none;
		}
	}

	&__sidebar {
		position: relative;
		min-width: 40px;
		width: 40px;
		display: flex;
		justify-content: center;
		cursor: grab;

		&:after {
			content: '';
			position: absolute;
			top: 0;
			right: -2px;
			width: 4px;
			height: 100%; //31px;
			border-radius: 2px;
			background-color: transparent;
			opacity: 0.85;
		}

		// &:before {
		// 	content: '';
		// 	position: absolute;
		// 	z-index: -1;
		// 	top: 0;
		// 	left: 0;
		// 	width: 100%;
		// 	height: 100%;
		// 	mask-image: linear-gradient(
		// 		180deg,
		// 		rgba(255, 255, 255, 0.5) 0%,
		// 		rgba(255, 255, 255, 0.5) 70%,
		// 		rgba(255, 255, 255, 0) 90%
		// 	);
		// 	background-image: url("data:image/svg+xml,%3Csvg width='100' height='20' viewBox='0 0 100 20' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M21.184 20c.357-.13.72-.264 1.088-.402l1.768-.661C33.64 15.347 39.647 14 50 14c10.271 0 15.362 1.222 24.629 4.928.955.383 1.869.74 2.75 1.072h6.225c-2.51-.73-5.139-1.691-8.233-2.928C65.888 13.278 60.562 12 50 12c-10.626 0-16.855 1.397-26.66 5.063l-1.767.662c-2.475.923-4.66 1.674-6.724 2.275h6.335zm0-20C13.258 2.892 8.077 4 0 4V2c5.744 0 9.951-.574 14.85-2h6.334zM77.38 0C85.239 2.966 90.502 4 100 4V2c-6.842 0-11.386-.542-16.396-2h-6.225zM0 14c8.44 0 13.718-1.21 22.272-4.402l1.768-.661C33.64 5.347 39.647 4 50 4c10.271 0 15.362 1.222 24.629 4.928C84.112 12.722 89.438 14 100 14v-2c-10.271 0-15.362-1.222-24.629-4.928C65.888 3.278 60.562 2 50 2 39.374 2 33.145 3.397 23.34 7.063l-1.767.662C13.223 10.84 8.163 12 0 12v2z' fill='%23ffffff' fill-opacity='1' fill-rule='evenodd'/%3E%3C/svg%3E");
		// }

		@each $name, $arr in $bucket_themes {
			&.#{$name} {
				&:after {
					background-color: nth($arr, 1);
				}
			}
		}
	}

	&__main {
		display: flex;
		flex-direction: column;
		justify-content: center;
		padding-left: $lg-margins;
		flex-grow: 1;

		.video {
			display: block;
		}
	}

	.c-avatar {
		margin-bottom: $lg-margins;
	}

	.c-list-controls {
		opacity: 0;
		transition: opacity 50ms linear;
	}

	&:hover {
		.c-list-controls {
			opacity: 1;
		}
	}
}
</style>
